import { Component } from '@angular/core';
import { LcsChipGridComponentBase } from 'src/app/common-components/chip-grid/chip-grid';
import { DeviceOption } from 'src/app/pages/phones/models/device-option.interface';

@Component({
    selector: 'ndt-device-chip-grid',
    templateUrl: 'device-chip-grid.component.html',
    standalone: false
})
export class DeviceChipGridComponent extends LcsChipGridComponentBase<DeviceOption> {
   trackBy(item: DeviceOption | null) {
      return item?.deviceId;
   }
}
